export const GET_SEARCHED_EXPERIENCES = "GET_SEARCHED_EXPERIENCES";
export const RESET_SEARCHED_EXPERIENCES = "RESET_SEARCHED_EXPERIENCES";
export const SET_SEARCHED_EXPERIENCES_REQUEST_STATUS = "SET_SEARCHED_EXPERIENCES_REQUEST_STATUS";
